import { usePerformanceChart, useTheme } from "@hooks";
import { constants } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const { width } = usePerformanceChart();

  const styles: Record<string, CSSProperties> = {
    container: {
      width,
      padding: constants.divPadding,
      backgroundColor: theme.chart.performance.background,
      borderRadius: constants.radius.view,
    },
    title: {
      fontWeight: 500,
      fontSize: 14,
    },
  };

  return styles;
};
